import AD from 'types/ad';
import PLAYER from 'types/player';
import _ from 'lodash';

const PREROLL_STATE = {
  IDLE: 'idle',
  PROCESSING: 'processing',
  ENDED: 'ended',
};

const initialState = {
  position: 0,
  adPaused: false,
  vastData: {
    duration: 15,
  },
  type: '',
  playing: false,
  timeToAdStart: 0,
  prerollState: PREROLL_STATE.IDLE,
};

const playerPropertyHandler = {
  adVendorState(state, payload) {
    if (payload.data === 2) {
      return { ...state, adPaused: true };
    } else if (payload.data === 1) {
      return { ...state, adPaused: false };
    }

    return state;
  },

  videoInfo(state /*, payload*/) {
    return {
      ...state,
      prerollState: PREROLL_STATE.IDLE,
    };
  },

  adSkipAd(state, payload) {
    return { ...state, skipedAd: payload.data };
  },
};

const mapPlayerPropertyHandlers = new Map([
  ['property:ad:vendor:state', playerPropertyHandler.adVendorState],
  ['property:videoInfo', playerPropertyHandler.videoInfo],
  ['property:ad:skipAd', playerPropertyHandler.adSkipAd],
]);

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case AD.HANDLE_EXTERNAL_CHANGE: {
      if (payload.name === 'ad:external:vastData') {
        return { ...state, ...initialState, ...payload.data };
      } else if (payload.name === 'ad:external:memberStartedPlaying') {
        return { ...state, ...payload.data, playing: true };
      } else if (payload.name === 'ad:external:vastEvent') {
        return {
          ...state,
          ...payload.data,
          timeToAdStart: payload.data.vastEvent === 'creativeView' ? 0 : state.timeToAdStart,
        };
      } else if (payload.name === 'ad:external:adWillStartIn') {
        return { ...initialState, timeToAdStart: payload.data };
      } else if (
        payload.name === 'ad:external:startedLoadingNewURL' &&
        _.get(payload, ['data', 'type']) === 'preroll'
      ) {
        return {
          ...state,
          prerollState: PREROLL_STATE.PROCESSING,
        };
      } else if (payload.name === 'ad:external:adComplete') {
        return {
          ...initialState,
          prerollState: PREROLL_STATE.ENDED,
        };
      }
      return state;
    }
    /*
  // TODO: ensure that it's no need any more, then remove
  // see app/utils/core.js:128
    case AD.HANDLE_POSITION_CHANGE:
      return { ...state, position: payload.data };
*/
    case AD.HANDLE_PAUSE_CHANGE:
      return { ...state, adPaused: payload };
    case PLAYER.HANDLE_CHANGE_PROPERTIES_PACK: // eslint-disable-line
      return payload.reduce(handlePlayerProperty, state);
    case PLAYER.HANDLE_CHANGE_PROPERTY: // eslint-disable-line
      return handlePlayerProperty(state, payload);
    default:
      return state;
  }
};

function handlePlayerProperty(state, payload) {
  return mapPlayerPropertyHandlers.has(payload.name)
    ? mapPlayerPropertyHandlers.get(payload.name)(state, payload)
    : state;
}
